import gql from 'graphql-tag';

export const GET_ALL_UPDATES = gql`
  query ($since: DateTime!, $status: [Int!] = [3, 4]){
    commandJobList(since: $since, status: $status) {
      status
      response
      data_affected
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/jobs/updates.js